<p>confirm-policy-dialog works!</p>
